<template>
  <div>
    <CrudDatabase
      v-if="tables.length > 0"
      :tables="tables"
      :currentCompany="getUserCompany"
    ></CrudDatabase>
  </div>
</template>

<script>
import crudJs from "./crud.js";
import CrudDatabase from "baron-vue-crud-databases";

export default {
  components: { CrudDatabase },
  computed: {
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  async mounted() {
    this.$store.commit("setLoader", true);
    await this.getTables();
    this.$store.commit("setLoader", false);
  },
  data: () => ({
    tables: [],
  }),
  methods: {
    async getTables() {
      const tables = await crudJs.getTables();
      if (tables.length > 0) {
        this.tables = [];
        tables.forEach((table) => {
          table.alevel = Number(table.alevel);
          this.tables.push(table);
        });
      }
    },
  },
};
</script>
